import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base';
import moment from 'moment';
import Employee from '../js/employee';
export default (function (props, ctx) {
  var d = new Date();
  var y = d.getFullYear();

  var profile = function profile() {
    Base.profile();
  };

  var criteria = Base.initdata.review_criteria;
  var scoreOptions = Base.initdata.review_scoring;
  var eventName = 'employeeSelected';
  var lastMonthValue = 'last-month';
  var empName = '';
  var comments = [];
  Base.app.off(eventName);
  Base.app.on(eventName, function (data) {
    $('.selected-employee').data('data', data);
    $('.selected-employee').html("Nh\xE2n vi\xEAn: <span class=\"text-color-white\">".concat(data.name, "</span>"));
    empName = data.name;
    ctx.$update(function () {
      //Xem kết quả
      viewResult();
    });
  }); //check dom ready?

  ctx.$onMounted(function () {
    $('.criteria-row .viewdetail-score').click( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
        var $target, emp, month, criteria, score, rs, names, criteriaObj, scoreOption, content;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                $target = $(e.target);
                emp = $('.selected-employee').data('data');
                month = $('.selected-time').data('month');
                month = month === undefined || month === null ? lastMonthValue : month;
                criteria = $target.dataset();
                score = $target.find('.score').text(); //Nếu score = "-" thì có nghĩa là không có kết quả đánh giá nào cả

                if (!(score.trim() === '-')) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                _context.next = 10;
                return Base.api('Review', 'viewdetail_score', {
                  emp: emp,
                  month: month,
                  criteria: criteria
                });

              case 10:
                rs = _context.sent;

                if (!(rs.status !== 'success' || rs.rows.length === 0)) {
                  _context.next = 13;
                  break;
                }

                return _context.abrupt("return");

              case 13:
                names = [];
                rs.rows.forEach(function (row) {
                  var emp = Employee.rows.find(function (e) {
                    return e.id === row.nguoi_danh_gia;
                  });
                  names.push(emp.name);
                });
                criteriaObj = Base.initdata.review_criteria.find(function (rc) {
                  return rc.id == criteria.id_criteria;
                });
                criteriaObj = criteriaObj ? criteriaObj : {
                  name: ''
                };
                scoreOption = Base.initdata.review_scoring.find(function (rs) {
                  return rs.score == criteria.id_score;
                });
                scoreOption = scoreOption ? scoreOption : {
                  name: '',
                  color: ''
                };
                content = "\n        <p>".concat(criteriaObj.name, ": <span class=\"text-color-").concat(scoreOption.color, "\">").concat(scoreOption.name, "</span></p>\n        <p>L\u01B0\u1EE3t \u0111\xE1nh gi\xE1: ").concat(names.length, "</p>\n        <p>Ng\u01B0\u1EDDi \u0111\xE1nh gi\xE1: ").concat(names.join(', '), "</p>\n      ");
                Base.app.dialog.create({
                  content: content,
                  destroyOnClose: true,
                  closeByBackdropClick: true,
                  buttons: [{
                    text: 'OK',
                    color: 'orange'
                  }]
                }).open();

              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
  });

  var viewResult = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      var emp, month, id_emp, rs, scores, id_tieuchi, objScores, id_score, score;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              emp = $('.selected-employee').data('data');
              month = $('.selected-time').data('month');

              if (!(emp === undefined || emp === null)) {
                _context2.next = 5;
                break;
              }

              Base.app.dialog.alert('Bạn cần chọn Nhân viên');
              return _context2.abrupt("return", false);

            case 5:
              month = month === undefined || month === null ? lastMonthValue : month;
              $('.comment-rows').html('');
              $('.criteria-row .score').text('-');
              id_emp = emp.id;
              _context2.next = 11;
              return Base.api('Review', 'viewResult', {
                id_emp: id_emp,
                month: month
              });

            case 11:
              rs = _context2.sent;

              if (!(comments.length === 0 && rs.scores.length === 0)) {
                _context2.next = 15;
                break;
              }

              Base.app.dialog.alert('Không có dữ liệu đánh giá');
              return _context2.abrupt("return", false);

            case 15:
              comments = rs.comments;
              if (comments.length > 0) ctx.$update();

              if (!(rs.scores.length === 0)) {
                _context2.next = 19;
                break;
              }

              return _context2.abrupt("return", false);

            case 19:
              scores = rs.scores;

              for (id_tieuchi in scores) {
                objScores = scores[id_tieuchi];

                for (id_score in objScores) {
                  score = objScores[id_score];
                  $(".criteria-row[data-id=\"".concat(id_tieuchi, "\"] div[data-id_score=\"").concat(id_score, "\"] .score")).text(score);
                }
              }

            case 21:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function viewResult(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var selectTime = function selectTime(e) {
    var setSelectedTime = function setSelectedTime(_ref3) {
      var month = _ref3.month,
          text = _ref3.text;
      $('.selected-time').data('month', month);
      $('.selected-time').html("Th\u1EDDi gian: <span class=\"text-color-white\">".concat(text, "</span>")); //Xem kết quả

      viewResult();
    };

    Base.app.dialog.create({
      content: "\n        <div><a class=\"button month-button\" data-month=\"all\">To\xE0n b\u1ED9</a></div>\n        <div><a class=\"button month-button\" data-month=\"".concat(lastMonthValue, "\">Th\xE1ng tr\u01B0\u1EDBc</a></div>\n        <div style=\"margin-top: 15px;\">Tu\u1EF3 ch\u1ECDn</div>\n        <div><input type=\"text\" name=\"month\" placeholder=\"M-YYYY\" style=\"width:100%; text-align:center; font-size: larger\" /></div>\n      "),
      destroyOnClose: true,
      closeByBackdropClick: true,
      on: {
        open: function open(dialog) {
          $(dialog.el).find('.month-button').click(function (e) {
            var month = $(e.target).data('month');
            var text = $(e.target).text();
            setSelectedTime({
              month: month,
              text: text
            });
            dialog.close();
          });
        }
      },
      buttons: [{
        text: 'Huỷ',
        color: 'gray'
      }, {
        text: 'OK',
        color: 'orange',
        onClick: function onClick(dialog) {
          var month = $(dialog.el).find('input[name="month"]').val();

          if (month === '') {
            Base.app.dialog.alert('Bạn cần chọn Tháng-Năm để xem đánh giá tuỳ chọn');
          } else {
            setSelectedTime({
              month: month,
              text: month
            });
          }
        }
      }]
    }).open();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="cross-review">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner">
      <div class="left"><a href="#" data-panel=".panel-left" class="panel-open" id="menu-bars"><i class="f7-icons icon">bars</i></a></div>
      <div class="title sliding">Kết quả đánh giá</div>
      <div class="right"><a href="#" @click=${profile} id="login-button"><i class="f7-icons icon">person_circle</i></a></div>
    </div>
  </div>
  <div class="page-content">
    <div class="list no-margin">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <a class="button selected-employee" href="/employee-list-popup/${eventName}">Chọn nhân viên</a>
          </div>
        </li>
        <li class="item-content item-input">
          <div class="item-inner">
            <a class="button selected-time" @click=${selectTime}>Chọn thời gian</a>
          </div>
        </li>
      </ul>
    </div>

    <div class="block">
      ${criteria.map(c=>$h`
        <div class="criteria-row" data-id="${c.id}">
          <div>${c.name}</div>
          <div class="row">
            ${scoreOptions.map(sc=>$h`
              <div class="scoring-col text-color-${sc.color} viewdetail-score" 
                data-id_criteria="${c.id}" 
                data-id_score="${sc.score}"
              >
                ${sc.name}: <a class="score text-color-${sc.color}">-</a>
              </div>
            `)}
          </div>
        </div>
      `)}
    </div>

    <div class="block">
      <p>Các góp ý về ${empName}</p>
      <div class="comment-rows">
        ${comments.map(comment=>$h`
          <div class="comment-row">
            <div class="datetime">${moment(comment.created_date).format(Base.dateTimeFormat)}</div>
            <span class="name">${comment.name}:</span> <span class="comment">${comment.comment}</span>
          </div>
        `)}
      </div>
    </div>

  </div>
</div>
`
    }
    ;
});